import ProductDetailsContainer from './ProductDetailsContainer';
export default ProductDetailsContainer;